(function () {
  'use strict';
  const ID = 'naxos-inventory-message';
  const SHOP = window.Shopify && window.Shopify.shop ? window.Shopify.shop : location.hostname;

  function updateMessage(qty) {
    const el = document.getElementById(ID);
    if (!el) return;
    if (qty === 1) {
      el.textContent = '⚠️ Ultimo pezzo disponibile';
      el.setAttribute('data-level', 'last');
      el.style.display = '';
    } else if (qty >= 2 && qty <= 3) {
      el.textContent = '🔥 Solo ' + qty + ' disponibili';
      el.setAttribute('data-level', 'low');
      el.style.display = '';
    } else {
      el.textContent = '';
      el.removeAttribute('data-level');
      el.style.display = 'none';
    }
  }

  function fetchQty(variantId) {
    const gid = 'gid://shopify/ProductVariant/' + variantId;
    const query = `{node(id:"${gid}"){...on ProductVariant{quantityAvailable}}}`;
    fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': document.querySelector('[data-storefront-api-token]')?.dataset.storefrontApiToken || ''
      },
      body: JSON.stringify({ query })
    })
    .then(r => r.json())
    .then(d => {
      const qty = d?.data?.node?.quantityAvailable;
      updateMessage(qty != null ? qty : null);
    })
    .catch(() => updateMessage(null));
  }

  function getCurrentVariantId() {
    const picker = document.querySelector('variant-picker');
    if (picker) {
      const checked = picker.querySelector('input[type="radio"]:checked');
      if (checked) return parseInt(checked.value, 10);
      const select = picker.querySelector('select');
      if (select) return parseInt(select.value, 10);
    }
    const hidden = document.querySelector('input[name="id"]');
    if (hidden) return parseInt(hidden.value, 10);
    return null;
  }

  function handleChange() {
    const id = getCurrentVariantId();
    if (id) fetchQty(id);
  }

  function init() {
    if (!document.getElementById(ID)) return;
    const picker = document.querySelector('variant-picker');
    if (picker) {
      picker.addEventListener('change', function () {
        setTimeout(handleChange, 50);
      });
    }
    document.addEventListener('variant:changed', handleChange);
    setTimeout(handleChange, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
